import { Alert, Link, Typography } from 'omakase';
import { useState } from 'react';
import SignInDialog from 'components/sign-in/SignInDialog';

interface PQCLoginFormProps {
  showModify: boolean;
  showCancel: boolean;
}

const PQCLoginForm: React.FC<React.PropsWithChildren<PQCLoginFormProps>> = ({
  showModify,
  showCancel,
}) => {
  const [openLogin, setOpenLogin] = useState<boolean>(false);

  const handleOpenDialog = () => {
    setOpenLogin(true);
  };

  const handleCloseDialog = () => {
    setOpenLogin(false);
  };

  return (
    <>
      {/*
        The first iteration of Paid Quick Checkout requires the user to log in or sign up, so once
        modify/cancel is enabled for PQC, the PQC alert/receipt button disabled logic should be removed.
      */}
      <Alert severity="info">
        <Typography mb={1}>
          To {showModify && <>modify{showCancel && ' or '}</>}
          {showCancel && 'cancel'} your reservation, please log in or sign up to create an account
          using the same email associated with the booked reservation.
        </Typography>
        <Typography>
          <Link onClick={handleOpenDialog} underline="none">
            Log in or sign up
          </Link>
        </Typography>
        <SignInDialog
          isOpen={openLogin}
          onClose={handleCloseDialog}
          onAuthComplete={handleCloseDialog}
        />
      </Alert>
    </>
  );
};

export default PQCLoginForm;
